import i18next from 'i18next';
export { default } from 'i18next';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { PROJECT_ID, DEFAULT_NAMESPACE } from '../config.js';

/**
 * This method recovers a namespaces list, first gets with common a unique list of namespaces,
 * using a filter to remove undefined/null/empty and a set to also remove repetitions.
 *
 * The order of preference loading the namespaces is the one specified in "namespace hierarchy" section in the README
 *
 * Considering this, we need:
 * - The namespaces list
 * - The last namespace as default (the last one is the most specific one, for example common, dpd, dpdnl)
 * - As fallback we need the rest of namespaces in reverse order
 *
 * For this reason, first we revert the array and we can use the destructuring to extract the first of the list (before applying the reverse was the last)
 * as default, and the rest of the list as default already in the correct order.
 */
const buildNamespaces = translationsNamespaces => {
  const ns = Array.from(new Set([DEFAULT_NAMESPACE, ...translationsNamespaces].filter(Boolean)));
  const [defaultNS, ...fallbackNS] = ns.reverse();
  return {
    ns,
    defaultNS,
    fallbackNS
  };
};
const getBackend = _ref => {
  let {
    cdn,
    application
  } = _ref;
  return new HttpApi(null, {
    loadPath: `${cdn}/translations/${PROJECT_ID[application]}/{{lng}}/{{ns}}.json`
  });
};
const getOptions = _ref2 => {
  let {
    defaultLanguage,
    locale,
    translationsNamespaces,
    availableLanguages,
    useSuspense,
    debug,
    resources
  } = _ref2;
  return {
    debug: debug !== null && debug !== void 0 ? debug : false,
    // Namespaces
    ...buildNamespaces(translationsNamespaces !== null && translationsNamespaces !== void 0 ? translationsNamespaces : []),
    // Language
    lng: locale,
    fallbackLng: defaultLanguage,
    supportedLngs: availableLanguages,
    // Others
    resources,
    keySeparator: false,
    load: 'currentOnly',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: useSuspense !== null && useSuspense !== void 0 ? useSuspense : true
    }
  };
};
const i18nInit = _ref3 => {
  let {
    backend,
    i18nOptions
  } = _ref3;
  /**
   * When using local resources we avoid using any backend
   */
  if (i18nOptions.resources) {
    return i18next.use(initReactI18next).init(i18nOptions);
  }
  return i18next.use(backend).use(initReactI18next).init(i18nOptions);
};

export { getBackend, getOptions, i18nInit };
//# sourceMappingURL=i18n.js.map
